import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { PhotoViewerPage } from '../photo-viewer/photo-viewer.page';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-show-user-reviews',
  templateUrl: './show-user-reviews.page.html',
  styleUrls: ['./show-user-reviews.page.scss'],
})
export class ShowUserReviewsPage implements OnInit {
  @Input('data') data;
  reviewData = [];
  Randomcolor = '';
  dataNotLoaded = true;
  userData: any;
  randomGradiant;
  constructor(
    public navCtrl: NavController,
    public platform: Platform,
    public server: ServerService,
    public globals: GlobalVariable,
    // public photoViewer:PhotoViewer,
    private sanitizer: DomSanitizer,
    private modalCtrl: ModalController
  ) {}
  ionViewWillEnter() {
    this.getColors();
    // let data=this.navParams.get('data')
    this.userData = this.data?.user;
    console.log(this.userData);
    this.fetchReviews();
  }

  ngOnInit() {}
  close() {
    this.modalCtrl.dismiss();
  }
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = '#';
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    this.Randomcolor = color;
    this.randomGradiant = this.sanitizer.bypassSecurityTrustStyle(
      'background:linear-gradient(180deg, ' + color + ' 0%, #ffffff 100%);'
    );
    console.log(this.randomGradiant);
    // console.log(this.Randomcolor)
  }
  fetchReviews() {
    this.server.showUserReviews(this.userData.user_email,this.userData.udid).subscribe(
      (res) => {
        this.dataNotLoaded = false;
        console.log(res);
        if (res.status) {
          this.reviewData = res.reviews;
        }
      },
      (err) => {
        this.globals.presentToast('Something went wrong, try again');
      }
    );
  }
  async openImage(image) {
    let modal = await this.modalCtrl.create({
      component: PhotoViewerPage,
      componentProps: { image: image },
    });
    modal.present();
    // var options = {
    //   share: true, // default is false
    //   closeButton: true, // iOS only: default is true
    //   copyToReference: true // iOS only: default is false
    // };

    // if (this.platform.is("ios")) {
    //   image = decodeURIComponent(image);
    // }

    // this.photoViewer.show(image, "Review image", options);

    // this.photoViewer.show(image);
  }
}
